<template>
  <div class="home">
    <mynav1 :dist="scrdist" :data='nvdata'></mynav1>
    <prod></prod>
    <myfooter :data='ftdata'></myfooter>
  </div>
</template>
<style>
</style>
<script>
// @ is an alias to /src
import {cmdata} from '@/assets/data/data'
require('@/assets/zt.css')
import cthead from '@/components/cthead'
import prod from '@/components/prod/zt8631'
import mynav1 from '@/components/mynav1'
import myfooter from '@/components/footer'



export default {
  components: {
    cthead,prod,mynav1,myfooter
  },
  data () {
    return {
      ovscroll: false,
      pdctdata: '',
      headdata: '',
      scrdist: 0,
      ftdata: {
        type: 'prod',
        lcallback: (stype) => {
          if (stype) {
            this.setHead(stype)
          }
        }
      },
      nvdata: {
        sindex: -1,
        type: 'prod',
        lcallback: (stype) => {
          if (stype) {
            this.setHead(stype)
          }
        }
      }
   
    }
  },
  computed: {
  
  },
  methods: {
    backToTop () {
      window.scrollTo(0,0)
    },
    onPageScroll (dist) {
      this.ovscroll = dist>93?true:false
      if (dist - this.scrdist > 93) {
        this.scrdist = dist
      } else if (dist < this.scrdist) {
        this.scrdist = dist
      }
      if (dist>0) this.ismenu=false
    },
    setRem() {
        var html = document.querySelector('html');
        var width = html.getBoundingClientRect().width;
        html.style.fontSize = width/20 + 'px'; /// 20
    },
    initWindowEv () {
      /// rem=px/2/14
      window.addEventListener('orientationchange', this.setRem);
      window.addEventListener('resize', this.setRem);
      this.setRem()

      var _this = this
      // var index = 1
      window.onscroll = function (e) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        _this.onPageScroll(scrollTop)
      }
    },
    setHead (type) {
      var item = cmdata['download']
      this.headdata = {
        title: item.title,
        desc: item.desc,
        pic: item.pic,
        wtype: 0,
        type: type,
        category: item.category,
        callback: (ctype) => {
          this.pdctdata = {
            type: ctype,
            data: item.data,
            category: item.scategory[ctype]
          }
          this.$router.replace({path:'/download',query:{stype: ctype}})
        }
      }

    },
    init () {
      var stype = this.$route.query.stype?this.$route.query.stype:'flexible'
      this.setHead(stype)
    }
  },
  mounted () {
    this.initWindowEv()
    this.init()
  }
}
</script>
